import { withCommon } from '@/services/translation/commonTranslations';
import LocalizedStrings from 'react-localization';

const tenantStrings = new LocalizedStrings({
  en: {
    superAdmin: {
      pageTitle: 'Tenant Settings',
      sectionTitle: 'Super Admin Settings',
      canDeleteRostersLabel: 'Can Delete Rosters',
      canDeleteRostersDescription: 'Whether daily rosters can be deleted',
      displayEmployeeIdsLabel: 'Display Employee IDs',
      displayEmployeeIdsDescription: 'Display employee IDs alongside names',
      maxCustomTemplatesLabel: 'Custom template maximum',
      maxCustomTemplatesDescription: 'The number of custom templates a customer can create',
      historicalDataLabel: 'Historical Data Displayed For',
      historicalDataDescription: 'How far back in time it is possible to display (plus the current month)',
      sectionContactsRoles: 'Contacts & Roles',
      advancedContractsLabel: 'Standard or Advanced',
      advancedContractsDescription:
        'Standard means tenant-wide settings applied to all employees. Advanced enables contacts to be defined for individual roles, which are then assigned to employees.',
      sectionLeaveSettings: 'Leave Settings',
      sectionLeaveSettingsDescription: 'Settings related to leave management features',

      leaveTypeTierLabel: 'Leave Type Tier',
      leaveTypeTierDescription: 'Select which plan this tenant uses',
      leaveTypeTierStandard: 'Standard',
      leaveTypeTierAdvanced: 'Advanced',

      sectionAdvancedProperties: 'Optimiser Parameters',
      sectionAdvancedPropertiesDescription: 'Use with caution',

      optimiserDurationLabel: 'Optimiser runtime duration',
      optimiserDurationDescription:
        "Number of seconds the optimiser will run (assembling/disassembling the payload isn't included in the timeframe!)",

      optimiserManagementAttendanceLabel: 'Management persona in attendance',
      optimiserManagementAttendanceDescription: 'Hard constraint to force attendance for at least one shift per roster',
      sectionFeatureAvailability: 'Feature Availability',
      sectionFeatureAvailabilityDescription:
        'Enable or disable tenant-facing product areas when they are available in backstage.',
      clockInOutLabel: 'Clock in and out',
      clockInOutDescription: 'Controls the clock in and out experience for this tenant.',
      payLabel: 'Pay',
      payDescription: 'Controls pay-related displays and editing for this tenant.',
      featureDefault: 'Use backstage default',
      featureEnabled: 'Enabled',
      featureDisabled: 'Disabled',
      featureDisabledByBackstage: 'Disabled by backstage'
    },
    admin: {
      pageTitle: 'Tenant Settings',
      sectionLeaveType: 'Leave Settings',
      sectionLeaveTypeDescription: 'Settings related to leave management features',
      sectionRosterSettings: 'Roster Settings',
      sectionRosterSettingsDescription: 'Settings related to the roster view',
      sectionEssBehaviour: 'ESS Behaviour',
      sectionEssBehaviourDescription: 'Controls whether ESS users can update their own contact details.',
      sectionHolidaySettings: 'Holiday Settings',
      sectionHolidaySettingsDescription: 'Choose the default holiday region for this tenant.',
      sectionLeaveSettings: 'Leave Settings',
      sectionLeaveSettingsDescription: 'Configure how leave is managed across your organisation.',
      sectionOptimisationSettings: 'Optimisation',
      sectionOptimisationSettingsDescription:
        'Choose which optimisation solver configuration can be used for this tenant and whether Optimisation Evaluation is available on Rosters.',

      minuteIncrementLabel: 'Minute increment',
      minuteIncrementDescription: 'Controls the smallest unit of time in the roster view.',

      allowEssWorkingPatternsLabel: 'ESS Working Patterns',
      allowEssWorkingPatternsDescription: 'Staff can request changes to their general working pattern in ESS.',

      allowEssAvailabilityAdjustmentLabel: 'ESS Availability Adjustment',
      allowEssAvailabilityAdjustmentDescription: 'Staff can request availability changes for specific days in ESS.',

      defaultHolidayRegionCodeLabel: 'Default holiday region',
      defaultHolidayRegionCodeDescription: "Used as the tenant's default holiday region.",
      defaultHolidayRegionCodeEnglandAndWales: 'England & Wales',
      defaultHolidayRegionCodeScotland: 'Scotland',
      defaultHolidayRegionCodeNorthernIreland: 'Northern Ireland',
      defaultHolidayRegionCodeIreland: 'Eire',
      allowEssEditEmailLabel: 'Allow ESS to edit own email',
      allowEssEditEmailDescription: 'If enabled, ESS users can update their own email address from their profile.',
      allowEssEditPhoneNumberLabel: 'Allow ESS to edit own phone number',
      allowEssEditPhoneNumberDescription: 'If enabled, ESS users can update their own phone number from their profile.',
      enabledSolversLabel: 'Enabled solver',
      enabledSolversDescription: 'Choose whether this tenant uses Genetic Algorithm, CP-SAT, or allows both.',
      optimisationEvaluationLabel: 'Show Optimisation Evaluation',
      optimisationEvaluationDescription:
        'Controls whether the Optimisation Evaluation button and modal are available on the Rosters page.',
      enabledSolversGeneticAlgorithm: 'Genetic Algorithm',
      enabledSolversCpSat: 'CP-SAT',
      enabledSolversBoth: 'Genetic Algorithm and CP-SAT',
      leaveTypeTier: 'Leave Type Tier',
      leaveTypeTierDescription: 'Select which plan this tenant uses',
      standard: 'Standard',
      advanced: 'Advanced',
      contract: {
        title: 'Contract Settings',
        description: 'Settings related to contract management features',
        contractTier: 'Contract Tier',
        contractTierDescription: 'Select which plan this tenant uses'
      },
      leaveCarryOver: 'Carry over leave',
      leaveCarryOverDescription:
        'The number of unused leave days an employee can carry over into the next leave period. Set to 0 to disable carry over.',
      leaveYearStartMonthLabel: 'Leave Year Start Month',
      leaveYearStartMonthDescription:
        'The month when leave balances reset. The leave year starts on the first day of this month.'
    }
  }
});

export default withCommon<typeof tenantStrings>(tenantStrings);
